export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/imgPlaceholder.4250ca18.gif","height":293,"width":391,"blurWidth":0,"blurHeight":0};